import { useEffect } from 'react';

/**
 * Le register se fait sur l'admin (SSO partagé).
 * Ce composant redirige immédiatement vers admin/register avec fromSource=site.
 */
export default function Register() {
  useEffect(() => {
    const adminUrl =
      (import.meta.env.VITE_URL_ADMIN as string | undefined)?.replace(/\/$/, '') || 'http://localhost:5231';
    const ownParams = new URLSearchParams(window.location.search);
    const ref = ownParams.get('ref');
    const claimClubId = ownParams.get('claimClubId');
    const redirectTo = claimClubId
      ? encodeURIComponent(`/creer-mon-club?claimClubId=${claimClubId}`)
      : encodeURIComponent('/');
    const params = new URLSearchParams({ fromSource: 'site', redirectTo });
    if (ref) params.set('ref', ref);
    if (claimClubId) params.set('claimClubId', claimClubId);
    window.location.replace(`${adminUrl}/register?${params.toString()}`);
  }, []);

  return null;
}
